import type { NewBuildPropertyItem } from "./properties";

// Sort precedence for the New Build listing page (when not sorted by price):
//   1. listingOrder ascending (lower = higher in the list)
//   2. date descending using the first defined of listingViewDate, createdAt,
//      last_synced_at (`listingViewDate` is the canonical listing-order field
//      bumped by admins; the remaining fields are legacy fallbacks for rows
//      that have not yet been touched).
export function compareNewBuildListingOrder(
  a: NewBuildPropertyItem,
  b: NewBuildPropertyItem,
): number {
  const orderA = a.listingOrder ?? 0;
  const orderB = b.listingOrder ?? 0;
  if (orderA !== orderB) return orderA - orderB;
  const dateA = new Date(
    a.listingViewDate || a.createdAt || a.last_synced_at || 0,
  ).getTime();
  const dateB = new Date(
    b.listingViewDate || b.createdAt || b.last_synced_at || 0,
  ).getTime();
  return dateB - dateA;
}
